export const HeroSection = () => {
  return (
    <section className='pt-[88px] pb-24 text-center bg-white'>
      <div className='container mx-auto px-8 max-w-[1120px]'>
        <p className='text-base font-bold uppercase tracking-widest text-brand-500 mb-4'>
          An invitation
        </p>

        <h1 className='text-display-md md:text-display-xl font-bold text-gray-700 tracking-tight mx-auto mb-4 max-w-[20ch]'>
          Design what’s next with us.
        </h1>

        <div className='text-xl leading-relaxed text-gray-500 max-w-[64ch] mx-auto mb-10 flex flex-col gap-4'>
          <p>We&rsquo;re evolving the experience for individual professionals on our platform.</p>
          <p>Things are paused while we design the next phase.</p>
          <p>We want to design it with you.</p>
        </div>

        <button
          type='button'
          onClick={() => {
            document.getElementById('perspective')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }}
          className='inline-flex items-center justify-center h-14 px-8 rounded-lg bg-brand-500 text-white text-lg font-semibold border-0 cursor-pointer shadow-sm transition-colors hover:bg-brand-600'
        >
          Provide your perspective
        </button>
      </div>
    </section>
  );
};
